@if (visible()) {
<div [ngStyle]="flexStyle" class="jk-margin0 ">
  <div>
    <app-jkfieldlabel [displayLabel]="displayLabel()" [label]="label()"
      [emojiLabel]="emojiLabel()"></app-jkfieldlabel>
  </div>
  <div class="w-full jk-margin0 flex-col gap-1">
        <app-jkbtnedit #edA [displayLabel]="true" [label]="titleA" [maintable]="maintable()" [item]="item()" [disabled]="disabled()" [readonly]="readonly()"
          [valueExpr]="valueExpr()" [displayExpr]="displayExpr()"
          [visible]="visible()" [showOpenWinButton]="showOpenWinButton()"
          [width]="editWidth"
          (valueChange)="onValueAChange($event)" [(value)]="valueA" [required]="required()">
        </app-jkbtnedit>
        <app-jkbtnedit #edB [displayLabel]="true" [label]="titleB" [maintable]="maintable()" [item]="item()" [disabled]="disabled()" [readonly]="readonly()"
        [visible]="visible()" [showOpenWinButton]="showOpenWinButton()"
        [valueExpr]="valueExpr()" [displayExpr]="displayExpr()"
        [width]="editWidth"
        (valueChange)="onValueBChange($event)" [(value)]="valueB" [required]="required()">
        </app-jkbtnedit>

</div>
</div>


<!--   <table class="jk-margin0">
    <tr class="jk-margin0">
      <td>
      </td>
      @if (displayLabel()) {
        <td size="auto" class="jk-margin0">
          <label class="jk-title">
            {{label()}}
          </label>
        </td>
      }
      <td>
        @if (required()) {
          <label style="color:red">*</label>
        }
      </td>
    </tr>
  </table>
  <table>
    <tr>
      <td>
        <app-jkbtnedit #edA [displayLabel]="true" [label]="titleA" [maintable]="maintable()" [item]="item()" [disabled]="disabled()" [readonly]="readonly()"
          [valueExpr]="valueExpr()" [displayExpr]="displayExpr()"
          [visible]="visible()" [showOpenWinButton]="showOpenWinButton()"
          [width]="editWidth"
          (valueChange)="onValueAChange($event)" [(value)]="valueA" [required]="required()">
        </app-jkbtnedit>
      </td>
    </tr>
    <tr>
      <td>
        <app-jkbtnedit #edB [displayLabel]="true" [label]="titleB" [maintable]="maintable()" [item]="item()" [disabled]="disabled()" [readonly]="readonly()"
        [visible]="visible()" [showOpenWinButton]="showOpenWinButton()"
        [valueExpr]="valueExpr()" [displayExpr]="displayExpr()"
        [width]="editWidth"
        (valueChange)="onValueBChange($event)" [(value)]="valueB" [required]="required()">
        </app-jkbtnedit>
      </td>
    </tr>
  </table>
 -->
}
